import { makeStyles } from '@mui/styles';
import FileUpload from 'apollo-react/components/FileUpload';
import Typography from 'apollo-react/components/Typography';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setPowerBIImportStep } from '../../actions/PowerBIActions';
import { IMPORT_STEPS } from '../../constants/PowerBIConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getCurrentRecordId } from '../../selectors/PowerBISelectors';

const useStyles = makeStyles({
  errorMessage: {
    color: 'red',
    marginTop: 10,
    textAlign: 'center',
  },
});

const UploadPowerBIFile = ({ selectedFiles, setSelectedFiles }) => {
  const translateString = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const currentRecordId = useSelector(getCurrentRecordId);

  const [uploadErrorMessage, setUploadErrorMessage] = useState('');

  useEffect(
    () => () => {
      setSelectedFiles([]);
      setUploadErrorMessage('');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleUpload = ([file]) => {
    setUploadErrorMessage('');
    const fileType = _.last(file.name.split('.'));

    if (!['pbix'].includes(fileType)) {
      setUploadErrorMessage('You can import only pbix files');
      return;
    }
    setSelectedFiles([file]);
    dispatch(setPowerBIImportStep(IMPORT_STEPS.UPLOAD_FILE, currentRecordId));
  };

  const handleDelete = () => {
    setSelectedFiles([]);
    dispatch(setPowerBIImportStep(IMPORT_STEPS.INITIAL_STEP, currentRecordId));
  };

  return (
    <>
      <FileUpload
        maxItems={1}
        fullWidth
        value={selectedFiles}
        onFileDelete={handleDelete}
        onUpload={handleUpload}
        dropAreaLabels={{
          activeText: translateString('Drop here to upload!'),
          browseLinkText: translateString('browse').toLowerCase(),
          defaultText: translateString('Drag files here or '),
          hoverText: translateString('Click to browse'),
          maxText: translateString('You can upload only one file'),
        }}
      />
      {uploadErrorMessage && (
        <Typography className={classes.errorMessage}>
          {translateString(uploadErrorMessage)}
        </Typography>
      )}
    </>
  );
};

export default UploadPowerBIFile;
